import { render, staticRenderFns } from "./StudentPayment.vue?vue&type=template&id=349ec763&scoped=true&"
import script from "./StudentPayment.vue?vue&type=script&lang=js&"
export * from "./StudentPayment.vue?vue&type=script&lang=js&"
import style0 from "./StudentPayment.vue?vue&type=style&index=0&id=349ec763&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349ec763",
  null
  
)

export default component.exports